import * as React from 'react';
import './Main/css/Main.css';

export default function AllFooter() {
  return (
    <footer>
      <h3>P2PAUTO</h3>
      <p>
        Professional Inspection. Transparent Information. Fair Transactions.
      </p>
      <br />
      <p>© 2026 P2PAUTO. All Rights Reserved.</p>
    </footer>
  );
}